export const QuotationFormStepTypes = {
  SERVICE: "service",
  COSTS: "costs",
  SCHEDULE: "schedule",
  MISC: "misc",
  CONFIRMATION: "confirmation",
};

export default QuotationFormStepTypes;
